import { getAxiosClient } from "src/services/axios-client";

const assistantAxiosClient = getAxiosClient(
  window._env_.ASSISTANT_API_BASE_URL
);

export const parseWebsiteToDevice = (url: string) => {
  return assistantAxiosClient.post("/parse-website-to-device", {
    url,
  });
};
